import PropTypes from 'prop-types'

import SwrConfig from '@/modules/swr'

import ErrorBoundary from './error-boundary'
import Navigation from './navigation'
import Notifications from './notifications'
import SessionReminder from './session-reminder'
import User from './user'

const Modules = ({ children }) => {
  return (
    <ErrorBoundary>
      <Notifications>
        <User>
          <Navigation>
            <SessionReminder>
              <SwrConfig>{children}</SwrConfig>
            </SessionReminder>
          </Navigation>
        </User>
      </Notifications>
    </ErrorBoundary>
  )
}

export default Modules

Modules.propTypes = {
  children: PropTypes.element.isRequired,
}
